/**
 * Constants for website environments.
 * NOTE: These are duplicated in next.config.js and should be kept in sync.
 */
const SITE_ENVIRONMENTS = {
  ACHIEVE: 'achieve',
  FDR: 'website-fdr',
  FFN: 'website-ffn',
  WFS: 'website-wfs',
  DEFAULT: 'achieve',
}

export { SITE_ENVIRONMENTS }
export default SITE_ENVIRONMENTS

